"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getBufferedDurationForStream(playbackPosition, bufferedRanges) {
    var duration = 0;
    bufferedRanges.forEach(function (bufferedRange) {
        var start = bufferedRange.start, end = bufferedRange.end;
        if ((start <= playbackPosition) && (end >= playbackPosition)) {
            duration = end - playbackPosition;
        }
    });
    return duration;
}
exports.default = getBufferedDurationForStream;
//# sourceMappingURL=getBufferedDurationForStream.js.map